import React from 'react';

import {IndexLink, Link} from 'react-router';
import {connect} from 'react-redux';
import * as commonApi from '../../../api/common-api';
import Loading from 'react-loading';
import axios from 'axios';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

var querystring = require('querystring');
import Textarea from 'react-textarea-autosize';
import store from '../../../store';
import ReactTooltip from 'react-tooltip'
import ReactAutolink from 'react-autolink'
import CommentBox from './CommentBox';
import Comment from './Comment';
import FeedPopup from './FeedPopup';
import LikePopup from './LikePopup';
import LoginPopup from '../LoginPopup';
import POPUP from '../popup';
import ShowMoreText from 'react-show-more-text';
import {Player, BigPlayButton, ControlBar} from 'video-react';
import TrackVisibility from 'react-on-screen';
import BoostJob from "../../../eappcomponents/commons/ppc/boostjob";
import Boosted from "../../../eappcomponents/commons/ppc/boosted";

var ReactDOM = require('react-dom');
//import AutoLinkText from 'react-autolink-text';
var relOptions = [
    {value: '0', label: 'Relevance'},
    {value: '1', label: '5 Star only'},
];
const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: '999',
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        position: 'relative',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        margin: '0',
        padding: '10px',
        width: '90%',
        height: '90%',
        minWidth: '800px',
        minHeight: '300px',
        zIndex: '999'
    }
};
const customStyles2 = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: '999',
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        position: 'relative',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        margin: '0',
        padding: '10px',
        width: '380px',
        height: '380px',
        minHeight: '300px',
        zIndex: '999'
    }
};
const customStyles3 = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: '999',
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        position: 'relative',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        margin: '0',
        padding: '80px 0px',
        width: '600px',
        height: '380px',
        minHeight: '300px',
        zIndex: '999',
        textAlign: 'center'
    }
};
const customStyles4 = {
    overlay : {
        position          : 'fixed',
        top               : 0,
        left              : 0,
        right             : 0,
        bottom            : 0,
        backgroundColor   : 'rgba(0, 0, 0, 0.3)',
        zIndex 				  : '999',
        overflow: 'auto'
    },
    content : {
        top                   : '15%',
        left                  : '50%',
        padding              : '12px',
        maxWidth             : '80%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        marginBottom         : '2%',
        transform             : 'translate(-50%, -15%)',
        zIndex 				  : '999',
        maxHeight              : '97vh',
    }
};

var courseId = 0;

class PlayerTest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            class_post: 'player-post-out'
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isVisible !== nextProps.isVisible) {
            if (nextProps.isVisible) {
                this.player.play();
            } else {
                this.player.pause();
            }
        }
    }

    mouseOut() {
        this.setState({class_post: 'player-post-out'});
    }

    mouseOver() {
        this.setState({class_post: 'player-post'});
    }

    render() {
        return <div className={this.state.class_post} onMouseOut={() => this.mouseOut()} onMouseOver={() => this.mouseOver()}><Player
            ref={(ref)=>this.player = ref}
            autoPlay={false}
            muted={true}>
            <source src={this.props.videoUrl}/>
            <BigPlayButton position="center" />
            <ControlBar autoHide={true} className="controlBar" />
        </Player></div>;
    }
}

class Feed extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            ref: undefined,
            showDD: false,
            activeDD: false,
            edit_mode: false,
            edit_text: "",
            showLikePU: false,
            showLoginPopover: false,
            msg: '',

            showPopover: false,
            showBootedPopover: false,
            isReach: false,
        };
        courseId = this.props.courseId;
        this.handleComment = this.handleComment.bind(this);
        this.addNoti = this.addNoti.bind(this);
        this._hideDropdown = this._hideDropdown.bind(this);

        this.handleClose = this.handleClosePopverClose.bind(this);
        this.handleBoostSubmit = this.handleBoostSubmitPopverClose.bind(this);
        this.handleBoostedClose = this.handleCloseBoostedPopverClose.bind(this);
    }

    componentDidMount() {
        window.addEventListener('click', this._hideDropdown, false);
    }

    componentWillUnmount() {
        // Remove click event listener on component unmount
        window.removeEventListener('click', this._hideDropdown, false);
    }

    handleLike(event) {
        if (this.props.user == 0) {
            this.setState({msg: 'like this post'});
            this.viewLoginPopover(event);
            return false;
        }
        var url = '/code/api_feeds.php?api=likeFeeds&id_feed=' + this.props.feed.id_feed + '&feed_type=' + this.props.feed.feed_type;
        axios.get(url)
            .then(response => {
                if (response.data.status == 1) {
                    var liked = 0;
                    if (this.props.feed.liked == 0) {
                        liked = 1;
                    }
                    var newFeed = Object.assign(this.props.feed, {likes: response.data.data, liked: liked});
                    this.props.handleFeedCallback(newFeed);
                }
                return response;
            });
    }

    // handleLike(event) {
    //     if (this.props.user == 0) {
    //         this.setState({msg: 'like this post'});
    //         this.viewLoginPopover(event);
    //         return false;
    //     }
    //     var url = '/code/apis.php?api=likeFeed&id_feed=' + this.props.feed.id_feed;
    //     if (this.props.feed.feed_type == 'job_post') {
    //         url = '/code/apis.php?api=likeJobPostFeed&id_feed=' + this.props.feed.id_feed;
    //     }
    //     axios.get(url)
    //         .then(response => {
    //             if (response.data.status == 1) {
    //                 var liked = 0;
    //                 if (this.props.feed.liked == 0) {
    //                     liked = 1;
    //                 }
    //                 var newFeed = Object.assign(this.props.feed, {likes: response.data.data, liked: liked});
    //                 if (this.props.feed.feed_type != 'job_post') {
    //                     if (liked == 1 && this.props.user.id_account != this.props.feed.user.id_account) {
    //                         var link = "/course/" + this.props.courseId;
    //                         var msg = "liked your post in " + this.props.course.code_course + ": " + this.props.course.name_course;
    //                         this.addNoti(msg, link, this.props.feed.user.id_account)
    //                     }
    //                 }
    //                 this.props.handleFeedCallback(newFeed);
    //                 //this.setState(Object.assign(this.state,{feeds:response.data.data}));
    //                 //store.dispatch(getUserSuccess(response.data.data));
    //             }
    //             //console.log(response.data);
    //
    //             return response;
    //         });
    // }

    addNoti(msg, link, u_id) {
        var data = new FormData();

        data.append('message', msg);
        data.append('link', link);
        data.append('u_id', u_id);
        axios.post(commonApi.getAPIURL() + '?api=addNoti', data)
            .then(response => {
                if (response.data.status == 1) {


                    var dataSend = {
                        from: this.props.user.id_account,
                        to: [this.props.feed.user.id_account],
                        noti: response.data.data
                    };
                    this.props.socket.emit('notification', JSON.stringify(dataSend));
                    //this.setState(Object.assign(this.state,{feeds:response.data.data}));
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);

                return response;
            });
    }

    handleCommentClick(event) {
        if (this.props.user == 0) {
            console.log("NOT LOGIN");
            this.setState({msg: 'comment this post'});
            this.viewLoginPopover(event);
            return false;
        }
        if (this.state.ref != undefined) {
            ReactDOM.findDOMNode(this.state.ref).focus();
        }
    }

    handleComment(comment, type = 'update') {
        if(type == "delete") {
            var comments_count = parseInt(this.props.feed.comments_count) - 1;
        }
        else {
            var comments_count = parseInt(this.props.feed.comments_count) + 1;
        }

        var newFeed = Object.assign(this.props.feed, {comments_count: comments_count});
        this.props.handleFeedCallback(newFeed);

        if (this.props.user.id_account != this.props.feed.user.id_account) {
            var link = "/course/" + this.props.courseId;
            var msg = "commented on your post in " + this.props.course.code_course + ": " + this.props.course.name_course;
            this.addNoti(msg, link, this.props.feed.user.id_account)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isVisible === true && this.state.isReach === false) {
            this.setState({isReach: true});
            this.handleReach();
        }
    }

    onClose() {
        this.setState({show: false});
    }

    onCloseLikePU() {
        this.setState({showLikePU: false});
    }

    onCloseLoginPopover() {
        this.setState({showLoginPopover: false});
    }

    viewLoginPopover(e) {
        this.setState({showLoginPopover: true});
    }

    onImageClick(e) {
        this.setState({show: true});
    }

    getInput(ref) {
        this.setState({ref: ref});
    }

    ddEditPost(e) {
        this.setState({edit_mode: true, edit_text: this.props.feed.content_feed});
    }

    ddDeletePost(e) {
        commonApi.confirm('Are you sure?').then(
            (result) => {
                var data = new FormData();
                data.append('id_feed', this.props.feed.id_feed);

                axios.post('/code/api_feeds.php?api=deleteFeeds', data)
                    .then(response => {
                        if (response.data.status == 1) {
                            var newFeed = Object.assign(this.props.feed, {});
                            this.props.handleFeedCallback(newFeed, "delete");
                            //this.setState(Object.assign(this.state,{feeds:response.data.data}));
                            //store.dispatch(getUserSuccess(response.data.data));
                        }
                        //console.log(response.data);
                        return response;
                    });
            },
            (result) => {
                // `cancel` callback
                //console.log('cancel called');
                //console.log(result)
            }
        );
    }

    ddToggleNoti(e) {

    }

    toggleDD(e) {
        e.stopPropagation();
        var showDD = !this.state.showDD;
        this.setState({showDD: showDD});
    }

    _hideDropdown() {
        var dropdownIsActive = this.state.activeDD;

        // Hide dropdown block if it's not active
        if (!dropdownIsActive && this.state.showDD) {
            this.setState({showDD: false});
        }
    }

    _handleFocus() {
        // Make active on focus
        this.setState({activeDD: false});
    }

    _handleBlur() {
        // Clean up everything on blur
        this.setState({
            showDD: false,
            activeDD: false
        });
    }

    handleTxtChange(event) {
        this.setState({edit_text: event.target.value});
    }

    handleCancelPost(e) {
        this.setState({edit_mode: false, edit_text: ""});
    }

    handleEditPost(e) {
        var c_feed = this.state.edit_text.trim();

        if (c_feed.length == 0) {
            commonApi.showAlert("Write something please!");
            return;
        }
        var data = new FormData();
        data.append('id_feed', this.props.feed.id_feed);
        data.append('content_feed', this.state.edit_text);
        axios.post('/code/api_feeds.php?api=updateFeeds', data)
            .then(response => {
                if (response.data.status == 1) {
                    var newFeed = Object.assign(this.props.feed, {content_feed: this.state.edit_text});
                    this.props.handleFeedCallback(newFeed);
                    this.setState({edit_mode: false, edit_text: ""});
                    //this.setState(Object.assign(this.state,{feeds:response.data.data}));
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);
                return response;
            });

    }

    viewLikePopup(e) {
        this.setState({showLikePU: true});
    }

    getFileType(type) {
        switch (parseInt(type)) {
            case 0:
                return "Notes"
                break
            case 1:
                return "Study Guides"
                break
            case 2:
                return "Flash Cards"
                break
        }
    }

    openLink(link, e) {
        window.open(link, "_blank");
    }

    extractDomain(url) {
        var domain;
        //find & remove protocol (http, ftp, etc.) and get domain
        if (url.indexOf("://") > -1) {
            domain = url.split('/')[2];
        }
        else {
            domain = url.split('/')[0];
        }
        //find & remove port number
        domain = domain.split(':')[0];

        return domain;
    }

    //boost jobs
    handleBoost = (event) => {
        this.setState({showPopover: true});
    }

    handleClosePopverClose = (event) => {
        this.setState({showPopover: false});
    }

    handleBoostSubmitPopverClose = (event) => {
        this.setState({showPopover: false, showBootedPopover: true});
    }

    //boosted

    handleCloseBoostedPopverClose = (event) => {
        this.setState({showBootedPopover: false});
    }

    //bid at the student side
    handleReach = () => {
        let url = "/code/api_feeds.php?api=studentReach";
        let data = new FormData();
        data.append("feed_type", this.props.feed.feed_type);
        data.append("id_feed", this.props.feed.id_feed);
        data.append("id_company", this.props.feed.id_company);
        axios.post(url, data)
            .then(response => {
                if (response.data.status === '1') {
                    console.log("the student is reaching!!")
                }
            })
            .catch(error => {
                console.log('function: handleReach');
                console.log(error);
            });
    }

    handleBid = (link, target, event) => {
        let url = "/code/api_feeds.php?api=studentBidding";
        let data = new FormData();
        data.append("feed_type", this.props.feed.feed_type);
        data.append("id_feed", this.props.feed.id_feed);
        data.append("id_company", this.props.feed.id_company);
        axios.post(url, data)
            .then(response => {
                if (response.data.status === '1') {
                    window.open(link, target);
                }
            })
            .catch(error => {
                console.log('function: handleBid');
                console.log(error);
            });
    }
	
	executeOnClick(isExpanded) {
        console.log(isExpanded);
    }

	render() {
        const feeditem = this.props.feed;
        const isMobile = this.props.isMobile;
		const context = <div
							 dangerouslySetInnerHTML={{__html: feeditem.des_job}}>
						</div>;
		const content_feed = <div
							 dangerouslySetInnerHTML={{__html: feeditem.content_feed}}>
						</div>;
        let likes = [];
        for (let like of feeditem.likes) {
            likes.push(<Link data-tip={like.full_name} to={like.avata_link} key={"f-like-" + feeditem.feed_type + like.id_like}><img className="img_circle_s" src={like.avata}/></Link>);
        }

        let onsite = '';
        if (this.props.user.id_company == null) {
            onsite = feeditem.area_applied === 'onsite' ?
                (<a className={"btn_v btn_cancel apply1 t-bold t-14"} onClick={this.handleBid.bind(this, feeditem.url_job, "_blank")}>Apply on Site</a>) :
                (<a className={"btn_v btn_cancel apply1 t-bold t-14"} onClick={this.handleBid.bind(this, "/jobsitedetail/" + feeditem.id_job + "2", "_self")}>Apply Now</a>);
        }
        else {
            onsite = <div className={"btn btn_confirm btn-md mr10"} onClick={this.handleBoost.bind(this)}>Boost Post</div>;
        }

        if (this.props.user === 0) {
            onsite = '';
        }

        let videoUrl = "";
        if (feeditem.videoUrl) {
            videoUrl= <TrackVisibility><PlayerTest videoUrl={feeditem.videoUrl}/></TrackVisibility>
        }

		return (
		    <div>
                <div className="page_course_box feed_section feed-font">
                    {this.props.user.id_account == this.props.feed.user.id_account ? (
                            <div className="post_option">
                                <a onClick={this.toggleDD.bind(this)} className="trigger"></a>
                                <div onBlur={this._handleBlur.bind(this)} onFocus={this._handleFocus.bind(this)} className={this.state.showDD?"popupDrop":"hide-el"}>
                                    <ul>
                                        <li className="post_icon_edit"><a onClick={this.ddEditPost.bind(this)}  >Edit post</a></li>
                                        <li className="post_icon_del"><a onClick={this.ddDeletePost.bind(this)}  >Delete post</a></li>
                                        <li className="post_icon_offnotify"><a onClick={this.ddToggleNoti.bind(this)}  >Turn off notifications</a></li>
                                    </ul>
                                </div>
                            </div>
                    ):""}
                    <div className="feed_top_box">
                        <div className="feed_top_left"><Link to={feeditem.avata_link}><img className="img_circle" src={feeditem.avata} alt=""/></Link></div>
                        <div className="feed_top_right">
                            <div className="feed_name user_name t-14 t-bold"><Link to={feeditem.avata_link}>{feeditem.name}</Link></div>
                            <div className="feed_user_major t-12 t-normal">{feeditem.sub_name}</div>
                        </div>
                    </div>
                    {feeditem.feed_type == 'job_feed' ?
                        <div className="feed_mid_box">
                            <div className="feed_content">
                                <div className={"bannerImage"}>
                                    {(feeditem.has_video_job == '0' || feeditem.has_video_job == '') ?
                                        <img src={feeditem.imgUrl}/>
                                        : <TrackVisibility><PlayerTest videoUrl={feeditem.videoUrl}/></TrackVisibility>
                                    }
                                </div>
                                <div className={"feed_title"}>{feeditem.title_job}</div>
								<div className={"job_content t-14"}>
								<ShowMoreText
									lines={3}
									more='Show more'
									less='Show less'
									anchorClass=''
									onClick={this.executeOnClick}
								>
								{context}
								</ShowMoreText>
								</div>
                                <div className={"feed_local"}>
                                    <div className={"text-left t-bold t-14"}>
                                        <span className={"pr10"}>{feeditem.location_job}</span>
                                        <span className={"pr10"}>{feeditem.employment_job}</span>
                                        {feeditem.salary_job}
                                    </div>
                                    <div className="btn-right">
                                        <p className={"t-bold t-14"}>{isMobile==1?feeditem.txt_opend_mobile:feeditem.txt_opend}</p>
                                        {onsite}
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="feed_mid_box">
                            {this.state.edit_mode ?
                                <div className="edit_post_w">
                                    <Textarea placeholder="" name="content" onChange={this.handleTxtChange.bind(this)} value={this.state.edit_text}/>
                                    <div className="edit_btns">
                                        <a onClick={this.handleCancelPost.bind(this)} className="btn_v btn_cancel">Cancel</a>
                                        <a onClick={this.handleEditPost.bind(this)} className="btn_v btn_confirm">Done</a>
                                    </div>
                                </div> :
                                <div>
                                    {feeditem.content_feed != ""?
                                        <div className="feed_content">
                                            <ShowMoreText
                                                lines={3}
                                                more='Show more'
                                                less='Show less'
                                                anchorClass=''
                                                onClick={this.executeOnClick}
                                            >
                                                {content_feed}
                                            </ShowMoreText>
                                            {videoUrl}
                                            {this.props.isPopup == undefined && feeditem.videoUrl == '' ? (<a className={"img-center"} onClick={this.onImageClick.bind(this)}><img src={feeditem.imgUrl}/></a>) : ""}
                                        </div>
                                        :""}
                                </div>
                            }
                            {feeditem.content_feed == "" && feeditem.preview != undefined?
                            <div>
                                <div className="feed_content t-14"
                                     dangerouslySetInnerHTML={{__html: ReactAutolink.autolink(feeditem.preview.content_feed)}}>
                                </div>
                            <div className="url_preview clickable">
                                <div className="file_review" onClick={this.openLink.bind(this, feeditem.preview.url_preview)}>
                                    <img src={feeditem.preview.img_preview}/>
                                </div>
                                <div className="file_info">
                                    <p className="file_name t-14 t-bold"><a href={feeditem.preview.url_preview} target="_blank">{feeditem.preview.title_preview}</a></p>
                                    <p className="file_type t-14">{this.extractDomain(feeditem.preview.url_preview)} • {feeditem.preview.des_preview}</p>
                                </div>
                            </div></div> : ""
                            }
                        </div>
                    }
                    <div className="feed_bot_box">
                        <div className="like_box">
                            <img src="/static/img/appimg/icon_like.png"/>&nbsp;&nbsp;&nbsp;<a className="like_btn" onClick={this.handleLike.bind(this)}>{feeditem.liked == 1?"You like":"Like"}&nbsp;</a>
                        </div>
                        <div className="comment_box">
                            <img src="/static/img/appimg/icon_com.png"/>&nbsp;&nbsp;&nbsp;<a onClick={this.handleCommentClick.bind(this)}>Comment&nbsp;({feeditem.comments_count})</a>
                        </div>
                        <div className="time_box">{feeditem.time_feed}</div>
                    </div>
                    {feeditem.likes.length > 0 ?
                    (
                        <div className="feed_bot_like_box">
                            <a onClick={this.viewLikePopup.bind(this)}><span>{feeditem.likes.length}</span>&nbsp;&nbsp;{feeditem.likes.length > 1 ? "Likes" : "Like"}&nbsp;&nbsp;</a>{likes}
                        </div>
                    ):""}
                    {feeditem.comments_count > 0 ?
                        (<Comment getInput={this.getInput.bind(this)} key={"comment-b-"+feeditem.id_feed} user={this.props.user} handleComment={this.handleComment} handleFeedCallback={this.props.handleFeedCallback} feed={feeditem}/>)
                        :
                        (<CommentBox getInput={this.getInput.bind(this)} user={this.props.user} onComment={this.handleComment} feed={feeditem}/>)
                    }
                </div>
                <POPUP style={customStyles} show={this.state.show} onClose={this.onClose.bind(this)} content={(<FeedPopup user={this.props.user} courseId={this.props.courseId} handleFeedCallback={this.props.handleFeedCallback} onClose={this.onClose.bind(this)} feed={this.props.feed} />)} />
                <POPUP style={customStyles2} show={this.state.showLikePU} onClose={this.onCloseLikePU.bind(this)} content={(<LikePopup user={this.props.user} onClose={this.onCloseLikePU.bind(this)} feed={this.props.feed} />)} />
                <POPUP style={customStyles3} show={this.state.showLoginPopover} onClose={this.onCloseLoginPopover.bind(this)} content={( <LoginPopup msg={this.state.msg} onClose={this.onCloseLoginPopover.bind(this)} />)} />
                <ReactTooltip place="top" type="info" effect="float"/>

                <POPUP show={this.state.showPopover}
                       overlayClick={false}
                       style={customStyles4}
                       onClose={this.handleClosePopverClose.bind(this)}
                       content={(<BoostJob handleClose={this.handleClose} handleBoostSubmit={this.handleBoostSubmit} user_profile={this.props.user} versity_job={true} jobs_id={this.props.feed.id_feed} feeditem={feeditem}/>)}
                />

                <POPUP show={this.state.showBootedPopover}
                       overlayClick={false}
                       style={customStyles4}
                       onClose={this.handleCloseBoostedPopverClose.bind(this)}
                       content={(<Boosted handleBoostedClose={this.handleBoostedClose} user_profile={this.props.user} versity_job={true} jobs_id={this.props.feed.id_feed} feeditem={feeditem}/>)}
                />
		    </div>
        );
  }
}

export default Feed;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/course/Feed.js
 **/